<div class="topbar">
  <div class="topbar__bar" [class.is--fixed]="fixed">
    <div class="container topbar__bar__inner">
      <h1 class="topbar__logo m-0 p" [class.is--fixed]="fixed">
        <a [routerLink]="'/'">
          <span class="sr-only">Volwassenen, Kinderen en Stofwisselingsziekten</span>
        </a>
      </h1>

      <div class="breadcrumbs">
        <ng-content></ng-content>
      </div>

      <div class="topbar-tools" [class.is--fixed]="fixed">
        <div class="search">
          <button class="button button-link button-link--muted" (click)="openMenu(true)">
            <fstr-icon [ariaHidden]="true" [anchor]="'icon-search'"></fstr-icon>
            <span class="d-none d-sm-inline-block">Zoeken</span>
            <span class="sr-only d-sm-none">Zoeken</span>
          </button>
        </div>
        <button class="hamburger-toggle-container button button button--secondary" (click)="openMenu(false)" #focusStart>
          <div class="hamburger-toggle">
            <span [class.hamburger-toggle__lines--active]="menuActive()" class="hamburger-toggle__lines"></span>
            <span class="ml-2 ml-sm-0 d-inline-block">
              @if (!menuActive()) {
                Menu
              }
              @if (menuActive()) {
                Sluiten
              }
            </span>
          </div>
        </button>
      </div>
    </div>
  </div>

  <!-- To be design and builed in an upcoming BLI -->
  @if (menuActive()) {
    <nav class="topbar__overlay" [@inOutAnimation] tabindex="-1" aria-modal="true" role="dialog">
      <div class="topbar-spacer"></div>
      <div class="container topbar__overlay__inner">
        <div class="section-inset-b text-center mt-6 mt-lg-0">
          <h2 class="text-white h3">{{ 'navigatie-zoek-titel' | fromDictionary }}</h2>
          <app-search-field
            class="d-flex justify-content-center mb-4 mt-3 mt-md-6"
            [type]="'secondary'"
            (searchInput)="handleSearchInput($event)"
            [placeholder]="'navigatie-zoek-placeholder' | fromDictionary"
            [focus]="setSearchFocus"
            (focused)="handleFocused($event)"
          ></app-search-field>
        </div>
        <div class="section-inset-b">
          <!-- <app-search-results
          *ngIf="q"
          [q]="q"
          [loading]="resultsLoading$()"
          (chosen)="closeNav()"
          [profiles]="profiles$()"
          [searchResults]="searchResults$()"
          [maxResults]="5"
          [showOtherResults]="true"
        ></app-search-results> -->
          @if (q) {
            <div class="results">
              <div class="results__inner">
                <app-search-result-list
                  [title]="'zoek-categorie-profiles-title' | fromDictionary"
                  [icon]="'icon-profiles'"
                  [loading]="false"
                  (chosen)="closeNav()"
                  [searchResults]="profiles$()"
                  [maxResults]="5"
                ></app-search-result-list>
                <app-search-result-list
                  [title]="'zoek-categorie-wisselstof-title' | fromDictionary"
                  [icon]="'icon-wisselstof'"
                  [loading]="magazineResultsLoading$()"
                  (chosen)="closeNav()"
                  [searchResults]="magazineSearchResults$()"
                  [maxResults]="5"
                ></app-search-result-list>
                <app-search-result-list
                  [title]="'zoek-categorie-other-title' | fromDictionary"
                  [icon]="'icon-other'"
                  [loading]="resultsLoading$()"
                  (chosen)="closeNav()"
                  [searchResults]="searchResults$()"
                  [maxResults]="5"
                ></app-search-result-list>
              </div>
            </div>
          }
        </div>
        @if (!q) {
          <div>
            <h1 class="h4 text-white">{{ 'navigatie-titel' | fromDictionary }}</h1>
            <ul class="topbar__nav-list row">
              @for (page of allMenuItems; track page) {
                <li class="topbar__nav-list__item col-12 col-md-6">
                  <a
                    (click)="closeNav()"
                    [routerLink]="page.url"
                    [routerLinkActive]="'is--current'"
                    [routerLinkActiveOptions]="{ exact: page?.pathMatchExact || false }"
                    #link="routerLinkActive"
                    class="topbar__nav-list__item__link"
                  >
                    <span>{{ page.menuTitle || page.title }}</span>
                    @if (link.isActive) {
                      <span class="label">{{ 'navigatie-active-link' | fromDictionary }}</span>
                    }
                    @if (!link.isActive) {
                      <div class="button button-icon button-icon--secondary button--sm">
                        <fstr-icon [ariaHidden]="true" anchor="icon-arrow-right"></fstr-icon>
                      </div>
                    }
                  </a>
                </li>
              }
              <li class="focus-only">
                <button class="text-white" (blur)="lastFocusable()" tabindex="0" (click)="closeNav()">Sluit navigatie</button>
              </li>
            </ul>
          </div>
        }
      </div>
    </nav>
  }
</div>
<div class="topbar-spacer"></div>
